import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
const getCountryCodeBasedImageUrl = urlCallback => countryCode => {
  switch (Country[countryCode]) {
    case Country.US:
    case Country.CA:
    case Country.GB:
      return urlCallback(countryCode);
    default:
      throw new Error(`Unsupported country code: ${countryCode}`);
  }
};
export const getCheckingUpsellImage = getCountryCodeBasedImageUrl(countryCode => `@banking/ui/assets/images/checking/upsell/card-en-${countryCode}.png`);
export const getOnboardingHeroImageUrl = getCountryCodeBasedImageUrl(countryCode => `@banking/ui/assets/images/checking/onboarding/hero-en-${countryCode}.png`);
export const getOnboardingUpsellImageUrl = getCountryCodeBasedImageUrl(countryCode => `@banking/ui/assets/images/checking/checking-onboarding-en-${countryCode}.png`);